<template>
  <div
    :class="['zg-avatar', {
      [`zg-avatar--size-${size}`]: size,
      [`zg-avatar--background-${background}`]: background
    }]"
  >
    <zg-image
      v-if="image && image.src"
      :src="image.src"
      :alt="image.alt"
      :title="image.title"
      lazy-load
    />

    <zg-product-icon
      v-else-if="product"
      :product="product"
    />

    <span v-else-if="text">
      {{ text }}
    </span>

    <zg-icon
      v-else
      icon="favorite-border"
      color="brand-500"
    />
  </div>
</template>

<script>
  import ZgIcon from '../ZgIcon/ZgIcon'
  import ZgImage from '../ZgImage/ZgImage'
  import ZgProductIcon from '../ZgProductIcon/ZgProductIcon'

  export default {
    name: 'ZgAvatar',
    components: {
      ZgIcon,
      ZgImage,
      ZgProductIcon
    },
    props: {
      image: {
        type: Object,
        required: false,
        default: null
      },
      product: {
        type: String,
        required: false,
        default: null
      },
      text: {
        type: String,
        required: false,
        default: null
      },
      size: {
        required: false,
        type: String,
        default: 'xlarge',
        validator: value => ['small', 'medium', 'large', 'xlarge'].includes(value)
      },
      background: {
        type: String,
        required: false,
        default: 'beige',
        validator: value => [
          'beige',
          'white'
        ].includes(value)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: color(brand-500);
    border-radius: 100%;
    overflow: hidden;

    ::v-deep img {
      min-width: 100%;
      min-height: 100%;
      object-fit: cover;
    }
  }

  // ? ----------------------------------------------------------------------
  // size
  // ? ----------------------------------------------------------------------

  .zg-avatar--size-small {
    @include type-title-xxs;

    width: rem(24px);
    height: rem(24px);
    margin: 0;

    ::v-deep svg {
      width: rem(16px);
      height: rem(16px);
    }
  }

  .zg-avatar--size-medium {
    @include type-title-xs;

    width: rem(40px);
    height: rem(40px);
    margin: 0;

    ::v-deep svg {
      width: rem(24px);
      height: rem(24px);
    }
  }

  .zg-avatar--size-large {
    @include type-title-s;

    width: rem(56px);
    height: rem(56px);
    margin: 0;

    ::v-deep svg {
      width: rem(32px);
      height: rem(32px);
    }
  }

  .zg-avatar--size-xlarge {
    @include type-title-m;

    width: rem(96px);
    height: rem(96px);
    margin: 0;

    ::v-deep svg {
      width: rem(60px);
      height: rem(60px);
    }
  }

  // ? ----------------------------------------------------------------------
  // background
  // ? ----------------------------------------------------------------------

  .zg-avatar--background-white {
    background-color: color(white);
  }

  .zg-avatar--background-beige {
    background-color: color(beige);
  }
</style>
